const scopesByOperationId = {
    "activateMfaCredential": [
        "i:w",
        "i{params.identityId}:w"
    ],
    "activeSkusInfo": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "acuDisableEnterpriseVpn": [
        "o-acu:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "acuEnableEnterpriseVpn": [
        "o-acu:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "acuShadowStateReport": [
        "o-acu:r",
        "o-acu:w",
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w"
    ],
    "addAcusToDeployTag": [
        "o:w"
    ],
    "addAlarmConfigurationCameraId": [
        "o:w",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:w"
    ],
    "applyAcuModelConfig": [
        "o-support:w",
        "o:w"
    ],
    "assignAcu": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "assignReader": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "attachOpvideoIntercomProfile": [
        "o:w",
        "o{orgId}-opvideoIntercom:w",
        "s-o:w"
    ],
    "autoRevertLockdownPlans": [
        "o:w"
    ],
    "blinkWirelessLockLed": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "buildAndSaveSwBundle": [
        "o:w"
    ],
    "buildSwBundle": [
        "o:r",
        "o:w"
    ],
    "bulkCreateThirdPartyDevices": [
        "o-support:w",
        "o:w"
    ],
    "bulkUpdateAcuSwConfigs": [
        "o:w"
    ],
    "cameraBootstrapEmbeddedPlayback": [
        "o-supportVideo:r",
        "o-supportVideo:w",
        "o:r",
        "o:w",
        "o{orgId}-user{params.userId}:r",
        "o{orgId}-user{params.userId}:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "cameraStaleSnapshot": [
        "o-supportVideo:r",
        "o-supportVideo:w",
        "o:r",
        "o:w",
        "o{orgId}-user{params.userId}:r",
        "o{orgId}-user{params.userId}:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "checkAcuSwConfigDeploy": [
        "o:r",
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcuSwConfig-checkAcuSwConfigDeploy:r",
        "o{orgId}-acu{params.acuId}:orgAcuSwConfig-checkAcuSwConfigDeploy:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "checkHeliumCoderActivityLevel": [
        "i:w"
    ],
    "checkHeliumCoderFavoriteAnimal": [
        "i:w"
    ],
    "checkSignedIdentityTermsAgreement": [
        "i{params.identityId}:identity-checkSignedIdentityTermsAgreement:w",
        "i{params.identityId}:w"
    ],
    "checkSignedOrgTermsAgreement": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "s-o-video:r",
        "s-o-video:w",
        "s-o:r",
        "s-o:w"
    ],
    "cleanupMapCameras": [
        "o:w",
        "o{orgId}-cleanupMsiAware:w"
    ],
    "cleanupMapExtras": [
        "o:w",
        "o{orgId}-cleanupMsiAware:w"
    ],
    "cloudKeyEntryUnlock": [
        "o:w",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "cloudKeyRevertLockdownPlan": [
        "o{orgId}-user{params.userId}:w"
    ],
    "cloudKeyTriggerLockdownPlan": [
        "o{orgId}-user{params.userId}:w"
    ],
    "completeHookAction": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-completeHookAction:w"
    ],
    "consolidateAndRenewSubscriptions": [
        "o-basic:w",
        "o:w"
    ],
    "createAcu": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "s-o:w"
    ],
    "createAcuDeployTag": [
        "o:w"
    ],
    "createAcuDiagnosticsReport": [
        "o-basic:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "createAcuExpansionBoard": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "s-o:w"
    ],
    "createAcuSwConfig": [
        "o:w"
    ],
    "createAlarmConfiguration": [
        "o:w",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:w"
    ],
    "createAndActivateLicenseBundle": [
        "o-basic:w",
        "o-support:w",
        "o:w"
    ],
    "createAuthCert": [
        "o:r",
        "o:w",
        "o{orgId}-cert:r",
        "o{orgId}-cert:w",
        "s-o:r",
        "s-o:w"
    ],
    "createAwareCamera": [
        "o:r",
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-awareConversion:r",
        "o{orgId}-acu{params.acuId}:orgAcu-awareConversion:w"
    ],
    "createBadgeConfig": [
        "o:w",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:w",
        "o{orgId}-mobileAppSettings:w",
        "s-o:w"
    ],
    "createBuilding": [
        "o:w",
        "o{orgId}-building:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "createBuildingFloor": [
        "o:w",
        "o{orgId}-building:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "createBuildingFloorUnit": [
        "o:w",
        "o{orgId}-building:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "createBundledSwConfig": [
        "o:w"
    ],
    "createCardOpenpathDesfireEv1": [
        "pc:w"
    ],
    "createCredential": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createCredentialAction": [
        "o-support:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createCredentialConfig": [
        "o-support:w",
        "o:w"
    ],
    "createCustomerOrgAwareConfig": [
        "o:w",
        "s-o-video:w",
        "s-o:w"
    ],
    "createCustomField": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createCustomFieldDropdownItem": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createDashboard": [
        "o:w",
        "o{orgId}-dash:w",
        "s-o:w"
    ],
    "createDeployTag": [
        "o:w"
    ],
    "createDmpDeployment": [
        "o:w",
        "s-o-video:w"
    ],
    "createEntry": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "createEntryState": [
        "o:w",
        "o{orgId}-entryState:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "createEvent": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createFeatureFlag": [
        "o-support:w",
        "o:w"
    ],
    "createGroup": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createHeliumCoder": [
        "i:w"
    ],
    "createHookAction": [
        "o:w",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:w",
        "s-o:w"
    ],
    "createIdentity": [
        "i:w"
    ],
    "createIdentityProvider": [
        "o:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createIdentityRole": [
        "i:w"
    ],
    "createIntercomDirectory": [
        "o:w",
        "o{orgId}-opvideoIntercom:w",
        "s-o:w"
    ],
    "createLockdownPlan": [
        "o:w",
        "o{orgId}-ldp:w",
        "s-o:w"
    ],
    "createMailroom": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "createMap": [
        "o:w",
        "o{orgId}-dash:w",
        "o{orgId}-map:w",
        "s-o:w"
    ],
    "createMapCamera": [
        "o:w",
        "o{orgId}-dash:w",
        "o{orgId}-map:w",
        "s-o:w"
    ],
    "createMapExtra": [
        "o:w",
        "o{orgId}-dash:w",
        "o{orgId}-map:w",
        "s-o:w"
    ],
    "createMfaCredential": [
        "i:w",
        "i{params.identityId}:w"
    ],
    "createMfaCredentialTempForAware": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createMusterSession": [
        "o:w",
        "o{orgId}-musterReport:w"
    ],
    "createOpvideoIntercomProfile": [
        "o:w",
        "o{orgId}-opvideoIntercom:w",
        "s-o:w"
    ],
    "createOrgBrandingPhoto": [
        "o-basic:w",
        "o:w",
        "o{orgId}-admin:w",
        "s-o-video:w",
        "s-o:w"
    ],
    "createOrgCancellation": [
        "o-basic:w",
        "o-support:w",
        "o:w",
        "o{orgId}-serviceCancellation:w"
    ],
    "createOrgFeatureFlag": [
        "o-support:w",
        "o:w"
    ],
    "createOrgFeatureFlagByName": [
        "o-support:w",
        "o:w"
    ],
    "createOrgFobAllegion": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createOrgMaintenanceWindow": [
        "o-basic:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "createOrgMaintenanceWindowDefinition": [
        "o-basic:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "createOrgPicture": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-mobileAppSettings:w",
        "s-o:w"
    ],
    "createParcel": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "createParcelPicture": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "createPropertyManagementSystem": [
        "o:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createReader": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "s-o:w"
    ],
    "createRecipientControl": [
        "o-support:w",
        "o:w"
    ],
    "createRequest": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w"
    ],
    "createRole": [
        "o-role:w",
        "o:w",
        "o{orgId}-role:w",
        "s-o:w"
    ],
    "createSchedule": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createScimAccessToken": [
        "o:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createSite": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createSosFacilityCampus": [
        "o:w",
        "o{orgId}-sos:w"
    ],
    "createSosFacilityOrg": [
        "o:w",
        "o{orgId}-sos:w"
    ],
    "createSubscription": [
        "o:w",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:w",
        "s-o:w"
    ],
    "createSubscriptionOverride": [
        "o:w"
    ],
    "createSwBundle": [
        "o:w"
    ],
    "createSwConfig": [
        "o:w"
    ],
    "createTasksReport": [
        "o-support:w",
        "o:w",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:w",
        "s-o:w"
    ],
    "createTasksReportsSchedule": [
        "o:w",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:w",
        "s-o:w"
    ],
    "createTermsAgreement": [
        "o{orgId}-admin:w"
    ],
    "createThirdPartyDevice": [
        "o-support:w",
        "o:w"
    ],
    "createUser": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createUserPicture": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "createVideoProvider": [
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:w"
    ],
    "createWidget": [
        "o:w",
        "o{orgId}-dash:w",
        "s-o:w"
    ],
    "createWirelessGateway": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "createWirelessLock": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "createWirelessLockGateway": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "createWirelessLockLogs": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "createWirelessLockProvider": [
        "o:w",
        "o{orgId}-integrations:w",
        "s-o:w"
    ],
    "createWirelessLockReader": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "createZone": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "createZoneApbArea": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "deleteAcu": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "s-o:w"
    ],
    "deleteAcuDeployTag": [
        "o:w"
    ],
    "deleteAcuExpansionBoard": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "s-o:w"
    ],
    "deleteAcuLocationMeasurement": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "deleteAcuLocationRestriction": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "deleteAcuSwConfig": [
        "o:w"
    ],
    "deleteAlarmConfiguration": [
        "o:w",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:w"
    ],
    "deleteAlarmConfigurationCameraId": [
        "o:w",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:w"
    ],
    "deleteAuthCert": [
        "o:w",
        "o{orgId}-cert:w",
        "o{orgId}-cert{params.authCertId}:w",
        "s-o:w"
    ],
    "deleteAwareDeployment": [
        "o-support:w",
        "o:w",
        "s-o-video:w"
    ],
    "deleteBadgeConfig": [
        "o:w",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:w",
        "o{orgId}-mobileAppSettings:w",
        "s-o:w"
    ],
    "deleteBuilding": [
        "o:w",
        "o{orgId}-building:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "deleteBuildingFloor": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-building:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "deleteBuildingFloorUnit": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-building:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "deleteBuiltSwBundle": [
        "o:w"
    ],
    "deleteBundledSwConfig": [
        "o:w"
    ],
    "deleteCredential": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteCredentialAction": [
        "o-support:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteCredentialConfig": [
        "o-support:w",
        "o:w"
    ],
    "deleteCustomField": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteCustomFieldDropdownItem": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteDashboard": [
        "o:w",
        "o{orgId}-dash:w",
        "s-o:w"
    ],
    "deleteDeployTag": [
        "o:w"
    ],
    "deleteEntry": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "deleteEntryState": [
        "o:w",
        "o{orgId}-entryState:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "deleteEvent": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteFeatureFlag": [
        "o-support:w",
        "o:w"
    ],
    "deleteGroup": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteHeliumCoder": [
        "i:w"
    ],
    "deleteHookAction": [
        "o:w",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:w",
        "s-o:w"
    ],
    "deleteIdentity": [
        "i:w",
        "i{params.identityId}:w"
    ],
    "deleteIdentityProvider": [
        "o:w"
    ],
    "deleteIdentityProviderGroupRelation": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteIdentityRole": [
        "i:w"
    ],
    "deleteIdentityUiState": [
        "i:w",
        "i{params.identityId}:w"
    ],
    "deleteIntercomDirectory": [
        "o:w",
        "o{orgId}-opvideoIntercom:w",
        "s-o:w"
    ],
    "deleteLockdownPlan": [
        "o:w",
        "o{orgId}-ldp:w",
        "s-o:w"
    ],
    "deleteMailroom": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "deleteMap": [
        "o:w",
        "o{orgId}-dash:w",
        "o{orgId}-map:w",
        "s-o:w"
    ],
    "deleteMapCamera": [
        "o:w",
        "o{orgId}-dash:w",
        "o{orgId}-map:w",
        "s-o:w"
    ],
    "deleteMapExtra": [
        "o:w",
        "o{orgId}-dash:w",
        "o{orgId}-map:w",
        "s-o:w"
    ],
    "deleteMfaCredential": [
        "i:w",
        "i{params.identityId}:w"
    ],
    "deleteMobileAppConfig": [
        "o:w",
        "o{orgId}-admin:w",
        "s-o:w"
    ],
    "deleteMusterSession": [
        "o:w",
        "o{orgId}-musterReport:w"
    ],
    "deleteOpVideoDeviceFacadeBackgroundImage": [
        "o-basic:w",
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "s-o:w"
    ],
    "deleteOpvideoIntercomProfile": [
        "o:w",
        "o{orgId}-opvideoIntercom:w",
        "s-o:w"
    ],
    "deleteOrg": [
        "o:w"
    ],
    "deleteOrgBrandingPhoto": [
        "o-basic:w",
        "o:w",
        "o{orgId}-admin:w",
        "s-o-video:w",
        "s-o:w"
    ],
    "deleteOrgFeatureFlag": [
        "o-support:w",
        "o:w"
    ],
    "deleteOrgFeatureFlagByName": [
        "o-support:w",
        "o:w"
    ],
    "deleteOrgMaintenanceWindow": [
        "o-basic:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "deleteOrgMaintenanceWindowDefinition": [
        "o-basic:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "deleteOrgNativeApp": [
        "o-support:w",
        "o:w",
        "s-o-video:w",
        "s-o:w"
    ],
    "deleteOrgPicture": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-mobileAppSettings:w",
        "s-o:w"
    ],
    "deleteParcel": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "deleteParcelPicture": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "deleteParcels": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "deletePropertyManagementSystem": [
        "o:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteReader": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "deleteRecipientControl": [
        "o-support:w",
        "o:w"
    ],
    "deleteRole": [
        "o-role:w",
        "o:w",
        "o{orgId}-role:w",
        "s-o:w"
    ],
    "deleteSchedule": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteScimAccessToken": [
        "o:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteSite": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteSiteLocationMeasurement": [
        "o:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "deleteSiteLocationRestriction": [
        "o:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "deleteSoftwareLicense": [
        "o-basic:w",
        "o:w"
    ],
    "deleteSosFacilityCampus": [
        "o:w",
        "o{orgId}-sos:w"
    ],
    "deleteSubscription": [
        "o:w",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:w",
        "s-o:w"
    ],
    "deleteSwBundle": [
        "o:w"
    ],
    "deleteSwConfig": [
        "o:w"
    ],
    "deleteTasksReport": [
        "o:w",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:w",
        "s-o:w"
    ],
    "deleteTasksReportsSchedule": [
        "o:w",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:w",
        "s-o:w"
    ],
    "deleteThirdPartyDevice": [
        "o-support:w",
        "o:w"
    ],
    "deleteUser": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteUserMfaCredential": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteUserPicture": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deleteVideoProvider": [
        "o-support:w",
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:w"
    ],
    "deleteWidget": [
        "o:w",
        "o{orgId}-dash:w",
        "s-o:w"
    ],
    "deleteWirelessGateway": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "deleteWirelessLock": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "deleteWirelessLockGateway": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "deleteWirelessLockProvider": [
        "o:w",
        "o{orgId}-integrations:w",
        "s-o:w"
    ],
    "deleteWirelessLockReader": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "deleteZone": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "deleteZoneApbArea": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "describeAcu": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeAcuDeployTag": [
        "o:r",
        "o:w"
    ],
    "describeAcuExpansionBoard": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeAcuLocationMeasurement": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeAcuModel": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeAcuOpvideoDeviceFacade": [
        "o:r",
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-getOpvideoDeviceFacade:r"
    ],
    "describeAcuPort": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeAcuPortEol": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeAcuPortType": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeAcuSwConfig": [
        "o:r",
        "o:w"
    ],
    "describeAcuTimezone": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeAlarm": [
        "o:r",
        "o:w",
        "o{orgId}-alarmActions:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptAlarm:r",
        "o{orgId}-rptAlarm:w"
    ],
    "describeAlarmAction": [
        "o:r",
        "o:w",
        "o{orgId}-alarmConfigurations:r",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w"
    ],
    "describeAlarmConfiguration": [
        "o:r",
        "o:w",
        "o{orgId}-alarmConfigurations:r",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w"
    ],
    "describeAlarmSeverity": [
        "o:r",
        "o:w",
        "o{orgId}-alarmConfigurations:r",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w"
    ],
    "describeAlarmStatus": [
        "o:r",
        "o:w",
        "o{orgId}-alarmConfigurations:r",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w"
    ],
    "describeAllMailroomStatistics": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeApp": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeAuthCert": [
        "o:r",
        "o:w",
        "o{orgId}-cert:r",
        "o{orgId}-cert:w",
        "o{orgId}-cert{params.authCertId}:r",
        "o{orgId}-cert{params.authCertId}:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeBadgeConfig": [
        "o:r",
        "o:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeBrandingProfile": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "s-o-video:r",
        "s-o-video:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeBuilding": [
        "o:r",
        "o:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeBuildingFloor": [
        "o:r",
        "o:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeBuildingFloorUnit": [
        "o:r",
        "o:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeBundledSwConfig": [
        "o:r",
        "o:w"
    ],
    "describeBundledSwConfigByComponents": [
        "o:r",
        "o:w"
    ],
    "describeCardFormat": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeContactSensor": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeCredential": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "describeCredentialAction": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeCredentialActionType": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeCredentialConfig": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w"
    ],
    "describeCredentialType": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeCustomField": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeCustomFieldDropdownItem": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeCustomFieldType": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeDashboard": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeDeployTag": [
        "o:r",
        "o:w"
    ],
    "describeEmailAlertType": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeEntry": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeEntryState": [
        "o:r",
        "o:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeEolSupervision": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeEvent": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeFeature": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "describeGenericInput": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeGroup": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeHeliumCoder": [
        "i:r",
        "i:w"
    ],
    "describeHookAction": [
        "o:r",
        "o:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeHookEvent": [
        "o:r",
        "o:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeIdentity": [
        "i:r",
        "i:w",
        "i{params.identityId}:r",
        "i{params.identityId}:w"
    ],
    "describeIdentityPreferenceSet": [
        "i:r",
        "i:w",
        "i{params.identityId}:r",
        "i{params.identityId}:w"
    ],
    "describeIdentityProvider": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeIdentityProviderType": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeIdentityRole": [
        "i:r",
        "i:w"
    ],
    "describeIdentityScopeResource": [
        "i:r",
        "i:w"
    ],
    "describeIntercomDirectory": [
        "o:r",
        "o{orgId}-opvideoIntercom:r",
        "s-o:r"
    ],
    "describeIntercomDirectoryQrCode": [
        "o:r",
        "o{orgId}-opvideoIntercom:r",
        "s-o:r"
    ],
    "describeIo": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeLocationMeasurementSourceType": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeLockdownPlan": [
        "o:r",
        "o:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeMailroom": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeMailroomStatistics": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeMap": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeMfaCredential": [
        "i:r",
        "i:w",
        "i{params.identityId}:r",
        "i{params.identityId}:w"
    ],
    "describeMobileAppConfig": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeMusterSession": [
        "o:r",
        "o:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w"
    ],
    "describeOperation": [
        "o:r"
    ],
    "describeOpvideoDevice": [
        "o-supportVideo:r",
        "o-supportVideo:w",
        "o:r",
        "o:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeOpvideoIntercom": [
        "o:r",
        "o{orgId}-opvideoIntercom:r",
        "s-o:r"
    ],
    "describeOpvideoIntercomProfile": [
        "o:r",
        "o:w",
        "o{orgId}-opvideoIntercom:r",
        "o{orgId}-opvideoIntercom:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeOrg": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-acu:org-findById:r",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-alarmActions:w",
        "o{orgId}-alarmConfigurations:r",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-erpParentCenter:w",
        "o{orgId}-erpParentStore:w",
        "o{orgId}-exportClips:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-opvideoIntercom:r",
        "o{orgId}-opvideoIntercom:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-presence:r",
        "o{orgId}-presence:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptAlarm:r",
        "o{orgId}-rptAlarm:w",
        "o{orgId}-rptDownload:r",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-serviceCancellation:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o-video:r",
        "s-o-video:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeOrgAwareConfig": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeOrgFobAllegion": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeOrgLevelDefault": [
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeOrgMaintenanceWindow": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeOrgMaintenanceWindowDefinition": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeOrgMaintenanceWindowMap": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeOrgOpvideoCameraStreamingProfile": [
        "o-liveVideo:w",
        "o:w",
        "o{orgId}-videoProviderLive:w",
        "s-o:w"
    ],
    "describeOrgPackagePlan": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeOrgPicture": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-mobileAppSettings:w",
        "s-o:w"
    ],
    "describeOrgSosFacilityOrgAssociation": [
        "o:w",
        "o{orgId}-sos:w"
    ],
    "describePackage": [
        "o:r",
        "o:w"
    ],
    "describePackagePackageFeature": [
        "o:r",
        "o:w"
    ],
    "describePackagePlan": [
        "o:r",
        "o:w"
    ],
    "describePalette": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeParcel": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeParcelPicture": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeParentOrgConfig": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-erpParentStore:w"
    ],
    "describePreferenceMeta": [
        "o:r",
        "o:w",
        "o{orgId}-user{params.userId}:r",
        "o{orgId}-user{params.userId}:w",
        "s-o:r",
        "s-o:w"
    ],
    "describePropertyManagementSystem": [
        "o:r",
        "o:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w"
    ],
    "describeReader": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeRecentAlarm": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w"
    ],
    "describeRecipientControl": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w"
    ],
    "describeRelay": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeRelayHardwareType": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeRex": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeRole": [
        "o-role:r",
        "o-role:w",
        "o:r",
        "o:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeSchedule": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeScheduleType": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeScopeResource": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeSharedUser": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeSite": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeSiteLocationMeasurement": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeSiteSosFacilityCampusAssociation": [
        "o:w",
        "o{orgId}-sos:w"
    ],
    "describeSosFacilityCampus": [
        "o:w",
        "o{orgId}-sos:w"
    ],
    "describeSosFacilityOrg": [
        "o:w",
        "o{orgId}-sos:w"
    ],
    "describeSubscription": [
        "o:r",
        "o:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeSwBundle": [
        "o:r",
        "o:w"
    ],
    "describeSwConfig": [
        "o:r",
        "o:w"
    ],
    "describeTasksReport": [
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptDownload:r",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeTasksReportLink": [
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptDownload:r",
        "s-o:r",
        "s-o:w"
    ],
    "describeTasksReportsSchedule": [
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeThirdPartyDevice": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w"
    ],
    "describeThirdPartyReader": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeThirdPartyWiegand": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeTriggerMethod": [
        "o:r",
        "o:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeUnusedInput": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeUser": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "o{orgId}-user{params.userId}:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeUserAcu": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:orgUser-describeUserAcu:r",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "describeUserBadge": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:orgUserBadge-describeUserBadge:r",
        "o{orgId}-user{params.userId}:r",
        "o{orgId}-user{params.userId}:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeUserCustomField": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "describeUserIntercomNotificationPreferenceSet": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "o{orgId}-user{params.userId}:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeUserPicture": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "describeUserPreferenceSet": [
        "o:r",
        "o:w",
        "o{orgId}-user{params.userId}:r",
        "o{orgId}-user{params.userId}:w"
    ],
    "describeVideoProvider": [
        "o:r",
        "o:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeWidget": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeWidgetType": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeWiegand": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeWirelessGateway": [
        "o:r",
        "o{orgId}-admin:r",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:r",
        "o{orgId}-site:r",
        "o{orgId}-siteGeneral:r",
        "s-o:r"
    ],
    "describeWirelessLock": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeWirelessLockGateway": [
        "o:r",
        "o{orgId}-admin:r",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:r",
        "o{orgId}-site:r",
        "o{orgId}-siteGeneral:r",
        "s-o:r"
    ],
    "describeWirelessLockProvider": [
        "o:r",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "s-o:r"
    ],
    "describeWirelessLockReader": [
        "o:r",
        "o{orgId}-admin:r",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:r",
        "o{orgId}-site:r",
        "o{orgId}-siteGeneral:r",
        "s-o:r"
    ],
    "describeZone": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "describeZoneApbArea": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "detachOpvideoIntercomProfile": [
        "o:w",
        "o{orgId}-opvideoIntercom:w",
        "s-o:w"
    ],
    "determineScheduleAccess": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "deunifyPartners": [
        "o-partnerUnificationTools:w"
    ],
    "enableOrgNativeApp": [
        "o:w",
        "s-o-video:w",
        "s-o:w"
    ],
    "endMusterSession": [
        "o:w",
        "o{orgId}-musterReport:w"
    ],
    "finalizeAppleWalletMetricReports": [
        "o:w"
    ],
    "generateActivityLogsFilter": [
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "generateAcuSsmActivation": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-generateSsmActivation:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "generateAppleWalletMetricReportRedshiftData": [
        "o:w"
    ],
    "generateAppleWalletMetricReportSqlData": [
        "o:w"
    ],
    "generateCloudKeyLockdownPlanActionToken": [
        "o:w",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "generateCloudKeyUnlockToken": [
        "o:w",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "generateCloudKeyUnlockTokenByModelId": [
        "o:w",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:orgUser-generateUnlockToken:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "generatePilotChildOrgLicensesReport": [
        "o:w"
    ],
    "generateSetupAcuToken": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "generateSetupMobileToken": [
        "o:w",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "getActivity": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "getActivityEvents": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "getAcuAwsCredentials": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-getAwsCredentials:w"
    ],
    "getAcuConfig": [
        "o-acu:r",
        "o-acu:w",
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-getConfig:r",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "getAcuDiagnosticsReport": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "getAcuLocationRestriction": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "getAcuSwConfigDeployProgress": [
        "o:r",
        "o{orgId}-acu{params.acuId}:orgAcuSwConfig-getAcuSwConfigDeployProgress:r",
        "o{orgId}-hw:r",
        "s-o:r"
    ],
    "getAlarmEvents": [
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptAlarm:r",
        "o{orgId}-rptAlarm:w"
    ],
    "getArgonThreads": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "getAuditLogs": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "s-o:r",
        "s-o:w"
    ],
    "getAuditLogsEvents": [
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "s-o:r",
        "s-o:w"
    ],
    "getAuditLogsUi": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "s-o:r",
        "s-o:w"
    ],
    "getAuditLogsUiEvents": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "s-o:r",
        "s-o:w"
    ],
    "getAuditLogsUiMasterMode": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w"
    ],
    "getAwareCamera": [
        "o:r",
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-awareConversion:r",
        "o{orgId}-acu{params.acuId}:orgAcu-awareConversion:w"
    ],
    "getAwsCredentials": [
        "i:r",
        "i:w"
    ],
    "getChanneltivityLogin": [
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "getCobaltThreads": [
        "o:r",
        "o:w",
        "o{orgId}-cobalt:r",
        "o{orgId}-cobalt:w",
        "s-o:r",
        "s-o:w"
    ],
    "getDbHealth": [
        "o:r",
        "o:w"
    ],
    "getDeviceTimeZoneDependentRelativeTimeRanges": [
        "o:r",
        "o:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "s-o:r",
        "s-o:w"
    ],
    "getEnterpriseVpnBootstrapConfig": [
        "o-acu:r",
        "o-acu:w",
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-getConfig:r",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "getEntryActivity": [
        "o:r",
        "o:w",
        "o{orgId}-entry:r",
        "o{orgId}-entry:w",
        "o{orgId}-entry{params.entryId}:r",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "getEntryActivityEvents": [
        "o:r",
        "o:w",
        "o{orgId}-entry:r",
        "o{orgId}-entry:w",
        "o{orgId}-entry{params.entryId}:r",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "getEntryPermissionInfo": [
        "o:r",
        "o:w"
    ],
    "getErpLogin": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-erpParentCenter:w",
        "o{orgId}-erpParentStore:w"
    ],
    "getHeliumCoderCupsOfCoffeePerDay": [
        "i:w"
    ],
    "getHeliumCoderFavoriteFood": [
        "i:r"
    ],
    "getHeliumCoderFavoriteGOTY": [
        "i:r"
    ],
    "getHeliumCoderFavoriteIndieGame": [
        "i:w"
    ],
    "getHeliumCoderFavoriteMusicalInstrument": [
        "i:r"
    ],
    "getHeliumCoderFavoritePlane": [
        "i:w"
    ],
    "getHeliumCoderFavoriteVacationDestination": [
        "i:r"
    ],
    "getHeliumCoderGifPronunciationPreference": [
        "i:w"
    ],
    "getHeliumCoderHoursCiv6Played": [
        "i:w"
    ],
    "getHeliumCoderLikesChocolate": [
        "i:w"
    ],
    "getHeliumCoderLikesDisney": [
        "i:w"
    ],
    "getHeliumCoderLikesSpicyFood": [
        "i:w"
    ],
    "getHeliumCoderLovesDogs": [
        "i:r"
    ],
    "getHeliumCoderNumberOfBoardGamesOwned": [
        "i:w"
    ],
    "getHeliumCoderPetSpecies": [
        "i:w"
    ],
    "getHeliumCoderSpiritAnimal": [
        "i:w"
    ],
    "getHeliumCoderWhoRulesTheWorld": [
        "i:w"
    ],
    "getIdentityProviderAuthUrl": [
        "o{orgId}-integrations:w",
        "o{orgId}-user:w"
    ],
    "getIdentityProviderGroupRelations": [
        "o:r",
        "o:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "getMqttCredentials": [
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-erpParentCenter:w",
        "o{orgId}-erpParentStore:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "getOpvideoIntercomWebRtcSessionInfo": [
        "o:w",
        "o{orgId}-user{params.userId}:orgUser-opvideoIntercomJoinSession:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "getOrgCaChain": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "s-o:r",
        "s-o:w"
    ],
    "getOrgSkuCompatibilityConfig": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "getParcelActivity": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "getParcelSignature": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "getPresenceBucketsReport": [
        "o:r",
        "o:w",
        "o{orgId}-presence:r",
        "o{orgId}-presence:w",
        "s-o:r",
        "s-o:w"
    ],
    "getPricingConfig": [
        "o:r",
        "o:w"
    ],
    "getReaderAdvertisementPrefix": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "getSamlAppMetadata": [
        "o:r",
        "o:w"
    ],
    "getSiteActivityEvents": [
        "o:r",
        "o:w",
        "o{orgId}-entry:r",
        "o{orgId}-entry:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "getSiteLocationRestriction": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "getSkuCompatibilityConfig": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "getSummaryStats": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "getSwConfigForAcu": [
        "o:r",
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcuSwConfig-getSwConfigForAcu:r",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "getUserActivity": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:orgUser-getUserActivity:r",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "getUserActivityEvents": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:orgUser-getUserActivity:r",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "getUserAwsCredentials": [
        "o{orgId}-user{params.userId}:orgUser-getAwsCredentials:r",
        "o{orgId}-user{params.userId}:r"
    ],
    "getWirelessLockDatabase": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "getWirelessLockEntryPermissionInfo": [
        "o:r",
        "o:w"
    ],
    "getWirelessLockProviderAppToken": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "globalDescribeBadgeDefaultConfig": [
        "o:r",
        "o:w"
    ],
    "globalDescribePreferenceMeta": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "globalDescribeWirelessGatewayBySerialNumber": [
        "o:r",
        "o:w"
    ],
    "globalDescribeWirelessLockGatewayBySerialNumber": [
        "o:r",
        "o:w"
    ],
    "globalDescribeWirelessLockProvider": [
        "o:r",
        "o:w"
    ],
    "globalDescribeWirelessLockReaderBySerialNumber": [
        "o:r",
        "o:w"
    ],
    "globalGetAuditLogs": [
        "o:r",
        "o:w"
    ],
    "globalGetStreamEventsPermissions": [
        "i{params.identityId}-agron:r",
        "i{params.identityId}-agron:w",
        "o:r",
        "o:w"
    ],
    "globalListAcus": [
        "o-acu:r",
        "o-acu:w",
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "globalListAcuSyncedShadowStates": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w"
    ],
    "globalListApps": [
        "o:r",
        "o:w"
    ],
    "globalListBadgeDefaultConfigs": [
        "o:r",
        "o:w"
    ],
    "globalListBillableFeatures": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "globalListEntries": [
        "o-acu:r",
        "o-acu:w",
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "globalListFobAllegions": [
        "o:r",
        "o:w"
    ],
    "globalListHookEvents": [
        "o:r"
    ],
    "globalListLockdownPlans": [
        "o:r"
    ],
    "globalListOpvideoDevices": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "globalListPreferenceMetas": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "globalListPushNotifications": [
        "o:r",
        "o:w"
    ],
    "globalListRequests": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "globalListSoftwareLicenses": [
        "o:r",
        "o:w"
    ],
    "globalListSubscriptions": [
        "o:r"
    ],
    "globalListThirdPartyDevices": [
        "o:r",
        "o:w"
    ],
    "globalListThirdPartyDeviceTypes": [
        "o:r",
        "o:w"
    ],
    "globalListUsers": [
        "i:r",
        "i:w"
    ],
    "globalListVideoProviders": [
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "globalListWirelessGateways": [
        "o:r"
    ],
    "globalListWirelessLockGateways": [
        "o:r"
    ],
    "globalListWirelessLockReaders": [
        "o:r"
    ],
    "globalListWirelessLocks": [
        "o:r"
    ],
    "globalNotifyMissingAcuLogs": [
        "o-support:w",
        "o:w",
        "s-o:w"
    ],
    "globalReapClearedAlarms": [
        "o:w"
    ],
    "globalReapDeletedAllegionOperators": [
        "o:w"
    ],
    "globalReapExpiredTasksReports": [
        "o:w"
    ],
    "globalReapOutdatedParcels": [
        "o:w"
    ],
    "globalRestartAbandonedTasksReports": [
        "o:w"
    ],
    "globalSyncAcuShadowStates": [
        "o-support:w",
        "o:w",
        "s-o:w"
    ],
    "globalSyncAllegionSites": [
        "o:w"
    ],
    "globalSyncTasksReportsSchedules": [
        "o:w"
    ],
    "globalSyncWirelessLockProviderDevices": [
        "o:w"
    ],
    "globalUpdateBadgeDefaultConfig": [
        "o:w"
    ],
    "globalUpdateFobAllegion": [
        "o:w"
    ],
    "globalUploadFobAllegionOrder": [
        "o-support:w",
        "o:w"
    ],
    "handleAsyncCustomerUnification": [
        "o:w"
    ],
    "identityProviderSyncUsers": [
        "o:w"
    ],
    "identitySendFeedback": [
        "i{params.identityId}:w"
    ],
    "inactivateIdentityProvider": [
        "o:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "injectEventAcuStatusConnected": [
        "o-event:w",
        "o:w"
    ],
    "injectEventAcuStatusDisconnected": [
        "o-event:w",
        "o:w"
    ],
    "injectMsiAwareHookEvent": [
        "o:w",
        "o{orgId}-eventsMsiAware:w"
    ],
    "installApp": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "s-o:w"
    ],
    "installLegacyApp": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "s-o:w"
    ],
    "inviteWirelessLockProviderOperator": [
        "o:w",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:w",
        "s-o:w"
    ],
    "labelSwConfig": [
        "o:w"
    ],
    "legacyToLicenseBillingInfo": [
        "o:r",
        "o:w"
    ],
    "listAcuDeployTags": [
        "o:r",
        "o:w"
    ],
    "listAcuExpansionBoards": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "listAcuLocationMeasurements": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "listAcuModels": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "s-o:r",
        "s-o:w"
    ],
    "listAcuPorts": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listAcuPortTypes": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "listAcus": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listAcuSwConfigs": [
        "o:r",
        "o:w"
    ],
    "listAcuUserOrgs": [
        "o:r",
        "o:w"
    ],
    "listAlarmActions": [
        "o:r",
        "o:w",
        "o{orgId}-alarmConfigurations:r",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w"
    ],
    "listAlarmConfigurationCameras": [
        "o:r",
        "o:w",
        "o{orgId}-alarmConfigurations:r",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w"
    ],
    "listAlarmConfigurations": [
        "o:r",
        "o:w",
        "o{orgId}-alarmConfigurations:r",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w"
    ],
    "listAlarmSeverities": [
        "o:r",
        "o:w",
        "o{orgId}-alarmConfigurations:r",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w"
    ],
    "listAlarmStatuses": [
        "o:r",
        "o:w",
        "o{orgId}-alarmConfigurations:r",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w"
    ],
    "listAllAcuPorts": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listApps": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "s-o:r",
        "s-o:w"
    ],
    "listAuthCerts": [
        "o:r",
        "o:w",
        "o{orgId}-cert:r",
        "o{orgId}-cert:w",
        "s-o:r",
        "s-o:w"
    ],
    "listBadgeConfigs": [
        "o:r",
        "o:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listBadgeDefaultConfigs": [
        "o:r",
        "o:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "s-o:r",
        "s-o:w"
    ],
    "listBuildingFloors": [
        "o:r",
        "o:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "listBuildingFloorUnitCameras": [
        "o:r",
        "o:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "listBuildingFloorUnitGroups": [
        "o:r",
        "o:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "listBuildingFloorUnits": [
        "o:r",
        "o:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listBuildingFloorUnitUsers": [
        "o:r",
        "o:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "listBuildings": [
        "o:r",
        "o:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "listBundledSwConfigs": [
        "o:r",
        "o:w"
    ],
    "listCameraEntries": [
        "o-supportVideo:r",
        "o-supportVideo:w",
        "o:r",
        "o:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listCancellations": [
        "o-basic:r",
        "o-basic:w",
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "listCardFormats": [
        "o:r",
        "o:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listChildOrgRequests": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "s-o:r",
        "s-o:w"
    ],
    "listChildOrgsSoftwareLicenseSubscriptions": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-erpParentStore:w",
        "s-o:r",
        "s-o:w"
    ],
    "listContactSensors": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listCredentialActions": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listCredentialActionTypes": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listCredentialConfigs": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w"
    ],
    "listCredentials": [
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:orgUser-listCredentials:r",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "listCredentialTypes": [
        "o:r",
        "o:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listCustomFieldDropdownItems": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listCustomFields": [
        "o:r",
        "o:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listCustomFieldTypes": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listDashboards": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "s-o:r",
        "s-o:w"
    ],
    "listDeployTags": [
        "o:r",
        "o:w"
    ],
    "listEmailAlerts": [
        "o:r",
        "o:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEmailAlertTypes": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntries": [
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntriesPost": [
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryCameras": [
        "o:r",
        "o:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryContactSensors": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryControls": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryHookEventRecords": [
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryHookEventRecordsPost": [
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryReaders": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryRelays": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryRexs": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryStates": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryThirdPartyReaders": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryThirdPartyWiegands": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryUsers": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryUserSchedules": [
        "o:r",
        "o:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEntryWiegands": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEolSupervisions": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "listEvents": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listFeatureFlagOrgs": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w"
    ],
    "listFeatureFlags": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w"
    ],
    "listFeatureOrgs": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "listFeatures": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "listGenericInputs": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "listGroupBuildingFloorUnits": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listGroupEntries": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listGroups": [
        "o:r",
        "o:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listGroupsPost": [
        "o:r",
        "o:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listGroupUserIds": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listGroupUsers": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listGroupZoneGroups": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listGroupZones": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listHeliumCoders": [
        "i:r",
        "i:w"
    ],
    "listHookActions": [
        "o:r",
        "o:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "s-o:r",
        "s-o:w"
    ],
    "listHookEvents": [
        "o:r",
        "o:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "s-o:r",
        "s-o:w"
    ],
    "listIdentities": [
        "i:r",
        "i:w"
    ],
    "listIdentityIdentityRoles": [
        "i:r",
        "i:w",
        "i{params.identityId}:r",
        "i{params.identityId}:w"
    ],
    "listIdentityNicknames": [
        "i:r",
        "i:w",
        "i{params.identityId}:r",
        "i{params.identityId}:w"
    ],
    "listIdentityProviderGroups": [
        "o:r",
        "o:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listIdentityProviders": [
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listIdentityProviderTypes": [
        "o:r",
        "o:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listIdentityProviderUserVideoUserGroups": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listIdentityRoleIdentities": [
        "i:r",
        "i:w"
    ],
    "listIdentityRoles": [
        "i:r",
        "i:w"
    ],
    "listIdentityRoleScopeIds": [
        "i:r",
        "i:w"
    ],
    "listIdentityScopeResources": [
        "i:r",
        "i:w"
    ],
    "listIdentityUiStates": [
        "i:r",
        "i:w",
        "i{params.identityId}:r",
        "i{params.identityId}:w"
    ],
    "listIdentityUsers": [
        "i:r",
        "i:w",
        "i{params.identityId}:r",
        "i{params.identityId}:w"
    ],
    "listIos": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listLocationMeasurementSourceTypes": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "listLockdownPlans": [
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-erpParentCenter:w",
        "o{orgId}-erpParentStore:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-videoIntercom:r",
        "o{orgId}-videoIntercom:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listMailrooms": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "listMapCameras": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "s-o:r",
        "s-o:w"
    ],
    "listMapExtras": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "s-o:r",
        "s-o:w"
    ],
    "listMaps": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "s-o:r",
        "s-o:w"
    ],
    "listMerakiNetworks": [
        "o:r",
        "o:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "s-o:r",
        "s-o:w"
    ],
    "listMfaCredentials": [
        "i:r",
        "i:w",
        "i{params.identityId}:r",
        "i{params.identityId}:w"
    ],
    "listMobileErrors": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:orgUser-sendFeedback:r",
        "o{orgId}-user{params.userId}:orgUser-sendFeedback:w",
        "o{orgId}-user{params.userId}:r",
        "o{orgId}-user{params.userId}:w",
        "s-o:r",
        "s-o:w"
    ],
    "listMobileSendFeedbackReasons": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:orgUser-sendFeedback:r",
        "o{orgId}-user{params.userId}:orgUser-sendFeedback:w",
        "o{orgId}-user{params.userId}:r",
        "o{orgId}-user{params.userId}:w",
        "s-o:r",
        "s-o:w"
    ],
    "listMusterSessions": [
        "o:r",
        "o:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w"
    ],
    "listMusterSessionUsers": [
        "o:r",
        "o:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w"
    ],
    "listNamespaces": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "s-o:r",
        "s-o:w"
    ],
    "listNativeApps": [
        "o:r",
        "o:w",
        "s-o-video:r",
        "s-o-video:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOperations": [
        "o:r"
    ],
    "listOpvideoDevices": [
        "o-supportVideo:r",
        "o-supportVideo:w",
        "o:r",
        "o:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOpvideoIntercomProfileGroups": [
        "o:r",
        "o:w",
        "o{orgId}-opvideoIntercom:r",
        "o{orgId}-opvideoIntercom:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOpvideoIntercomProfiles": [
        "o:r",
        "o:w",
        "o{orgId}-opvideoIntercom:r",
        "o{orgId}-opvideoIntercom:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOpvideoIntercomProfileTypes": [
        "o:r",
        "o:w",
        "o{orgId}-opvideoIntercom:r",
        "o{orgId}-opvideoIntercom:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOpvideoIntercomProfileUsers": [
        "o:r",
        "o:w",
        "o{orgId}-opvideoIntercom:r",
        "o{orgId}-opvideoIntercom:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgAcuDeviceUpdates": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgAcuSwConfigs": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgAcuSyncedShadowStates": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgAllFeatures": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-alertSettings:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-erpParentCenter:w",
        "o{orgId}-erpParentStore:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgBuildingFloorUnits": [
        "o:r",
        "o:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgCameras": [
        "o-supportVideo:r",
        "o-supportVideo:w",
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgCancellations": [
        "o-basic:r",
        "o-basic:w",
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-alarmActions:w",
        "o{orgId}-alarmConfigurations:r",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-building:r",
        "o{orgId}-building:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-opvideoIntercom:r",
        "o{orgId}-opvideoIntercom:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-presence:r",
        "o{orgId}-presence:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptAlarm:r",
        "o{orgId}-rptAlarm:w",
        "o{orgId}-rptDownload:r",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-serviceCancellation:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgCredentials": [
        "o:r",
        "o:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgFeatureFlags": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-alertSettings:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-erpParentCenter:w",
        "o{orgId}-erpParentStore:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-portalAudit:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o-video:r",
        "s-o-video:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgFeatures": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-alertSettings:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-erpParentCenter:w",
        "o{orgId}-erpParentStore:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-portalAudit:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgFobAllegions": [
        "o:r",
        "o:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgIdentities": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgMaintenanceWindowDefinition": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgMaintenanceWindowMap": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgNativeApps": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-acu:org-findById:r",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-erpParentCenter:w",
        "o{orgId}-erpParentStore:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o-video:r",
        "s-o-video:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgNoTourCredentialCommands": [
        "o:r",
        "o:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgNoTourCredentialSectorsPost": [
        "o:r",
        "o:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgNoTourCredentialSectorsValidationData": [
        "o:r",
        "o:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgOpvideoCameraStreamingProfiles": [
        "o-liveVideo:w",
        "o:w",
        "o{orgId}-videoProviderLive:w",
        "s-o:w"
    ],
    "listOrgOpvideoIntercomProfiles": [
        "o:r",
        "o:w",
        "o{orgId}-opvideoIntercom:r",
        "o{orgId}-opvideoIntercom:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgPackagePlans": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgPackagePlansSelected": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-map:r",
        "o{orgId}-map:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-videoIntercom:r",
        "o{orgId}-videoIntercom:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o-video:r",
        "s-o-video:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgPictures": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgs": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "s-o-video:r",
        "s-o-video:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgSoftwareLicenses": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgSoftwareLicensesForSubscription": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgSoftwareLicensesRenewalBundle": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgsPost": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "s-o-video:r",
        "s-o-video:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgUserVideoUserGroup": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listOrgWirelessLockDbEntries": [
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "listPackagePackageFeatures": [
        "o:r",
        "o:w"
    ],
    "listPackagePlans": [
        "o:r",
        "o:w"
    ],
    "listPackages": [
        "o:r",
        "o:w",
        "s-o-video:r",
        "s-o-video:w",
        "s-o:r",
        "s-o:w"
    ],
    "listPalettes": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "listParcelHistory": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "listParcelMessageTypes": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "listParcelPictures": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "listParcelPictureTypes": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "listParcels": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "listParcelStatuses": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "listPmsProperties": [
        "o:r",
        "o:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w"
    ],
    "listPreferenceMetas": [
        "o:r",
        "o:w",
        "o{orgId}-user{params.userId}:r",
        "o{orgId}-user{params.userId}:w",
        "s-o:r",
        "s-o:w"
    ],
    "listPropertyManagementSystems": [
        "o:r",
        "o:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w"
    ],
    "listReaders": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listRecentAlarms": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w"
    ],
    "listRecipientControls": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w"
    ],
    "listRelayHardwareTypes": [
        "o:r",
        "o:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "listRelays": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listRequests": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w"
    ],
    "listRexs": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listRoles": [
        "o-role:r",
        "o-role:w",
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listRoleScopeIds": [
        "o-role:r",
        "o-role:w",
        "o:r",
        "o:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "s-o:r",
        "s-o:w"
    ],
    "listRoleUserIds": [
        "o-role:r",
        "o-role:w",
        "o:r",
        "o:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "s-o:r",
        "s-o:w"
    ],
    "listRoleUsers": [
        "o-role:r",
        "o-role:w",
        "o:r",
        "o:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSchedules": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listScheduleTypes": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listScopeResources": [
        "o:r",
        "o:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSharedUsers": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSharedUsersPost": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSiteGroupIds": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSiteGroups": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSiteLocationMeasurements": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSites": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSiteUserIds": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSiteUsers": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSnapshots": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSoftwareLicenseSubscriptionRenewalBundle": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSoftwareLicenseSubscriptions": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSosFacilityPsaps": [
        "o:w",
        "o{orgId}-sos:w"
    ],
    "listSubscriptions": [
        "o:r",
        "o:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "s-o:r",
        "s-o:w"
    ],
    "listSwBundles": [
        "o:r",
        "o:w"
    ],
    "listSwConfigs": [
        "o:r",
        "o:w"
    ],
    "listTargetOfOrgNoTourCredentialCommands": [
        "o:r",
        "o:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "s-o:r",
        "s-o:w"
    ],
    "listTasksReports": [
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listTasksReportsSchedules": [
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listTermsAgreements": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "s-o:r",
        "s-o:w"
    ],
    "listThirdPartyReaders": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listThirdPartyWiegands": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listTriggerMethods": [
        "o:r",
        "o:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "s-o:r",
        "s-o:w"
    ],
    "listUnifyCustomerQueue": [
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "s-o-video:r",
        "s-o-video:w",
        "s-o:r",
        "s-o:w"
    ],
    "listUnusedInputs": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listUserAcus": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "listUserBuildingFloorUnits": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listUserCustomFields": [
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "listUserEntries": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "listUserGroups": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "listUserIntercomProfiles": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-opvideoIntercom:r",
        "o{orgId}-opvideoIntercom:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listUserMfaCredentials": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listUserPictures": [
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:r",
        "o{orgId}-credential:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-entryState:r",
        "o{orgId}-entryState:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-mobileAppSettings:r",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-outboundWebhooks:r",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "o{orgId}-user{params.userId}:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listUserRoles": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "listUsers": [
        "o-role:r",
        "o-role:w",
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listUserSites": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "listUsersPost": [
        "o-role:r",
        "o-role:w",
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listUserZones": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "listUserZoneUsers": [
        "o-user:r",
        "o-user:w",
        "o:r",
        "o:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:r",
        "s-o:r",
        "s-o:w"
    ],
    "listVideoProviderCameras": [
        "o:r",
        "o:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listVideoProviders": [
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-alertSettings:r",
        "o{orgId}-alertSettings:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-erpParentCenter:w",
        "o{orgId}-erpParentStore:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-portalAudit:r",
        "o{orgId}-portalAudit:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "listVideoProviderTypes": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:w",
        "s-o:r",
        "s-o:w"
    ],
    "listWidgets": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "s-o:r",
        "s-o:w"
    ],
    "listWidgetTypes": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "s-o:r",
        "s-o:w"
    ],
    "listWiegands": [
        "o:r",
        "o:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listWirelessGateways": [
        "o:r",
        "o{orgId}-admin:r",
        "o{orgId}-dash:r",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashEntry:r",
        "o{orgId}-hw:r",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:r",
        "o{orgId}-site:r",
        "o{orgId}-siteGeneral:r",
        "s-o:r"
    ],
    "listWirelessLockGateways": [
        "o:r",
        "o{orgId}-admin:r",
        "o{orgId}-dash:r",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashEntry:r",
        "o{orgId}-hw:r",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:r",
        "o{orgId}-site:r",
        "o{orgId}-siteGeneral:r",
        "s-o:r"
    ],
    "listWirelessLockProviderFirmwares": [
        "o:r",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "s-o:r"
    ],
    "listWirelessLockProviderOperators": [
        "o:r",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "s-o:r"
    ],
    "listWirelessLockProviders": [
        "o:r",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "s-o:r"
    ],
    "listWirelessLockProviderTypes": [
        "o:r",
        "o:w"
    ],
    "listWirelessLockReaders": [
        "o:r",
        "o{orgId}-admin:r",
        "o{orgId}-dash:r",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashEntry:r",
        "o{orgId}-hw:r",
        "o{orgId}-integrations:r",
        "o{orgId}-integrations:r",
        "o{orgId}-site:r",
        "o{orgId}-siteGeneral:r",
        "s-o:r"
    ],
    "listWirelessLocks": [
        "o:r",
        "o{orgId}-admin:r",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:r",
        "o{orgId}-site:r",
        "o{orgId}-siteGeneral:r",
        "s-o:r"
    ],
    "listZoneApbAreas": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listZoneGroupIds": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listZoneGroups": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listZones": [
        "o:r",
        "o:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-ldp:r",
        "o{orgId}-ldp:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-rpt:r",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "s-o:r",
        "s-o:w"
    ],
    "listZoneShares": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listZoneUserIds": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listZoneUsers": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listZoneZoneGroups": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "listZoneZoneUsers": [
        "o:r",
        "o:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:r",
        "o{orgId}-siteGeneral:w",
        "s-o:r",
        "s-o:w"
    ],
    "logHeliumCoderCountriesVisitedCount": [
        "i:w"
    ],
    "logHeliumCoderCupsOfCoffeePerDay": [
        "i:w"
    ],
    "logHeliumCoderFavoriteBook": [
        "i:w"
    ],
    "logHeliumCoderFavoriteCaffeineBeverage": [
        "i:w"
    ],
    "logHeliumCoderFavoriteFood": [
        "i:w"
    ],
    "logHeliumCoderFavoriteIndieGame": [
        "i:w"
    ],
    "logHeliumCoderFavoriteMusicalInstrument": [
        "i:w"
    ],
    "logHeliumCoderFavoritePlane": [
        "i:w"
    ],
    "logHeliumCoderFavoriteVacationDestination": [
        "i:w"
    ],
    "logHeliumCoderHeight": [
        "i:w"
    ],
    "logHeliumCoderLikesChocolate": [
        "i:w"
    ],
    "logHeliumCoderLikesDisney": [
        "i:w"
    ],
    "logHeliumCoderLikesSpicyFood": [
        "i:w"
    ],
    "logHeliumCoderLovesDogs": [
        "i:w"
    ],
    "logHeliumCoderRubiksSolve": [
        "i:w"
    ],
    "logHeliumCoderSpiritAnimal": [
        "i:w"
    ],
    "logHeliumCoderWhoRulesTheWorld": [
        "i:w"
    ],
    "logHeliumCoderXyzzy": [
        "i:w"
    ],
    "logLikesParasiteFilm": [
        "i:w"
    ],
    "logSnackDistance": [
        "i:w"
    ],
    "logSuperpower": [
        "i:w"
    ],
    "maintainNativeApps": [
        "o:w"
    ],
    "manageDeploymentStatus": [
        "o:w"
    ],
    "markNeedsNoTourUpdate": [
        "o:w"
    ],
    "masterCalcOrgsStatistics": [
        "o-support:w",
        "o:w"
    ],
    "masterDescribeOrg": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "masterListOrgs": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w"
    ],
    "mergePartnerCustomers": [
        "o-support:w",
        "o:w",
        "o{orgId}-admin:w"
    ],
    "mergeVideoPartner": [
        "o-partnerUnificationTools:w"
    ],
    "migrateAccessPartners": [
        "o:w"
    ],
    "migrateLegacyToLicense": [
        "o-basic:w",
        "o-support:w",
        "o:w"
    ],
    "migratePartnersToLicense": [
        "o:w"
    ],
    "migrateVideoPartners": [
        "o:w"
    ],
    "millicastBandwidthUsage": [
        "o-acu:r",
        "o-acu:w",
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "netsuitePlans": [
        "o-basic:r",
        "o-basic:w",
        "o:r",
        "o:w",
        "o{orgId}-account:r",
        "o{orgId}-account:w",
        "o{orgId}-admin:r",
        "o{orgId}-admin:w",
        "o{orgId}-badgePrinting:r",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:r",
        "o{orgId}-configurations:w",
        "o{orgId}-dash:r",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:r",
        "o{orgId}-dashActivity:w",
        "o{orgId}-dashAlarm:r",
        "o{orgId}-dashAlarm:w",
        "o{orgId}-dashEntry:r",
        "o{orgId}-dashEntry:w",
        "o{orgId}-entryAccessAudit:r",
        "o{orgId}-entryAccessAudit:w",
        "o{orgId}-erpParentCenter:w",
        "o{orgId}-erpParentStore:w",
        "o{orgId}-hw:r",
        "o{orgId}-hw:w",
        "o{orgId}-musterReport:r",
        "o{orgId}-musterReport:w",
        "o{orgId}-occupancyReport:r",
        "o{orgId}-occupancyReport:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "o{orgId}-quickStart:r",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:r",
        "o{orgId}-role:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-site:r",
        "o{orgId}-site:w",
        "o{orgId}-user:r",
        "o{orgId}-user:w",
        "o{orgId}-videoIntercom:r",
        "o{orgId}-videoIntercom:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "newArgonMessage": [
        "o-basic:w",
        "o:w"
    ],
    "newArgonThreadMessage": [
        "o-basic:w",
        "o:w"
    ],
    "newCobaltMessage": [
        "o:r",
        "o:w",
        "o{orgId}-cobalt:r",
        "o{orgId}-cobalt:w",
        "s-o:r",
        "s-o:w"
    ],
    "newCobaltThreadMessage": [
        "o:r",
        "o:w",
        "o{orgId}-cobalt:r",
        "o{orgId}-cobalt:w",
        "s-o:r",
        "s-o:w"
    ],
    "notifyAcuDiagnosticsReportIsReady": [
        "o-basic:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "opvideoDeviceCreateClipDownload": [
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-exportClips:w",
        "s-o:w"
    ],
    "opvideoDeviceDisableOnvif": [
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "s-o:w"
    ],
    "opvideoDeviceEnableOnvif": [
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "s-o:w"
    ],
    "opvideoDeviceGenerateObserverLiveToken": [
        "o-supportVideo:r",
        "o-supportVideo:w",
        "o:w",
        "s-o:w"
    ],
    "opvideoDeviceGenerateUserLiveToken": [
        "o:w",
        "o{orgId}-user{params.userId}:orgUser-opvideoIntercomJoinSession:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "opvideoDeviceGetDeviceToken": [
        "o:r",
        "o{orgId}-acu{params.acuId}:orgAcu-getConfig:r"
    ],
    "opvideoDeviceHlsPlaybackUrl": [
        "o-supportVideo:r",
        "o-supportVideo:w",
        "o:r",
        "o:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "opvideoDeviceListClips": [
        "o-supportVideo:r",
        "o-supportVideo:w",
        "o:r",
        "o:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "opvideoDeviceListFragments": [
        "o-supportVideo:r",
        "o-supportVideo:w",
        "o:r",
        "o:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:r",
        "s-o:w"
    ],
    "opvideoDevicePingStreaming": [
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-videoProviderLive:w",
        "s-o:w"
    ],
    "opvideoDeviceSimulateButtonPress": [
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "s-o:w"
    ],
    "opvideoDeviceSimulateMotion": [
        "o-supportVideo:w",
        "o:w",
        "s-o:w"
    ],
    "opvideoDeviceStartLive": [
        "o:w",
        "o{orgId}-user{params.userId}:orgUser-opvideoIntercomJoinSession:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "opvideoDeviceStartRecording": [
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:w"
    ],
    "opvideoDeviceStartStreaming": [
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-videoProviderLive:w",
        "s-o:w"
    ],
    "opvideoDeviceStopStreaming": [
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-videoProviderLive:w",
        "s-o:w"
    ],
    "opvideoDeviceStreamingPublishToken": [
        "o-basic:r",
        "o-basic:w",
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "opvideoDeviceStreamingStatus": [
        "o-basic:r",
        "o-basic:w",
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w",
        "o{orgId}-opvideoDevice:r",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "s-o:r",
        "s-o:w"
    ],
    "opvideoDeviceStreamingSubscriberToken": [
        "o-supportVideo:r",
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:w"
    ],
    "opvideoDeviceTriggerConfigChange": [
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "s-o:w"
    ],
    "opvideoDeviceTriggerSnapshot": [
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-videoProviderLive:w",
        "s-o:w"
    ],
    "opvideoIntercomAnswerVideoCall": [
        "o:w",
        "o{orgId}-user{params.userId}:orgUser-opvideoIntercomJoinSession:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "opvideoIntercomDietOpixConfig": [
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "opvideoIntercomIceConfig": [
        "o:w",
        "o{orgId}-user{params.userId}:orgUser-opvideoIntercomJoinSession:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "opvideoIntercomOpixConfig": [
        "o:r",
        "o:w",
        "s-o:r",
        "s-o:w"
    ],
    "opvideoIntercomSignAwsRequest": [
        "o:w",
        "o{orgId}-user{params.userId}:orgUser-opvideoIntercomJoinSession:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "opvideoIntercomStartVideoCall": [
        "o:w",
        "o{orgId}-user{params.userId}:orgUser-opvideoIntercomJoinSession:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "opvideoIntercomStopVideoCall": [
        "o:w",
        "o{orgId}-user{params.userId}:orgUser-opvideoIntercomJoinSession:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "opvideoIntercomUpdateOpvideoIntercomProfile": [
        "o:w",
        "o{orgId}-opvideoIntercom:w",
        "s-o:w"
    ],
    "opvideoIntercomUpdateOpvideoIntercomProfiles": [
        "o:w",
        "o{orgId}-opvideoIntercom:w",
        "s-o:w"
    ],
    "orgCompleteHookAction": [
        "o-completeHookAction:w",
        "o:w"
    ],
    "orgGetOpvideoDeviceFacade": [
        "o-basic:r",
        "o:r",
        "o{orgId}-opvideoDevice:r",
        "s-o:r"
    ],
    "orgUpdateOpvideoDeviceFacade": [
        "o-basic:w",
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "s-o:w"
    ],
    "patchMap": [
        "o:w",
        "o{orgId}-dash:w",
        "o{orgId}-map:w",
        "s-o:w"
    ],
    "processQuantityLimits": [
        "o:w"
    ],
    "processRenewals": [
        "o:w"
    ],
    "processWalletAppleIncomingEvents": [
        "o:w"
    ],
    "pruneExpiredShortUrls": [
        "o:w"
    ],
    "reapCredentialsFromInactiveUsers": [
        "o:w"
    ],
    "reapDeletedAllegionMobiles": [
        "o:w"
    ],
    "reapDeletedAndExpiredScimAccessTokens": [
        "o:w"
    ],
    "reapDeletedMobiles": [
        "o:w"
    ],
    "reapDeletedWalletApples": [
        "o:w"
    ],
    "reapDeletedWallets": [
        "o:w"
    ],
    "reapExpiredAccessTokens": [
        "i:w"
    ],
    "reapProcessedWalletAppleIncomingEvents": [
        "o:w"
    ],
    "recalculateBillableFeatures": [
        "o:w"
    ],
    "recalculateCredentialCounts": [
        "o:w"
    ],
    "recalculateStaleBillableFeatures": [
        "o-basic:w",
        "o:w"
    ],
    "reissueAcuCertificate": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-reissueAcuCertificate:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "relinquishZoneShare": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "remoteAcuIdentify": [
        "o-support:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "remoteAcuReboot": [
        "o-acu:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "remoteAcuRefreshShadow": [
        "o-support:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "remoteAcuRestartApi": [
        "o-support:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "remoteAcuRestartCloud": [
        "o-support:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "remoteAcuRestartHardware": [
        "o-support:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "remoteAcuRunCommand": [
        "o-acu:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "remoteEntryIdentify": [
        "o:w",
        "o{orgId}-hw:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "remoteReaderIdentify": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "remoteReaderRestart": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "removeAcusFromDeployTag": [
        "o:w"
    ],
    "removeContactSensorFromEntry": [
        "o:w",
        "o{orgId}-hw:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "removeGroupFromSite": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "removeGroupFromZone": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "removeIdentityFromIdentityRole": [
        "i:w"
    ],
    "removeReaderFromEntry": [
        "o:w",
        "o{orgId}-hw:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "removeRelayFromEntry": [
        "o:w",
        "o{orgId}-hw:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "removeRexFromEntry": [
        "o:w",
        "o{orgId}-hw:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "removeThirdPartyReaderFromEntry": [
        "o:w",
        "o{orgId}-hw:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "removeThirdPartyWiegandFromEntry": [
        "o:w",
        "o{orgId}-hw:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "removeUserFromGroup": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "removeUserFromRole": [
        "o-role:w",
        "o:w",
        "o{orgId}-role:w",
        "s-o:w"
    ],
    "removeUserFromSite": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "removeUserFromZone": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "removeWiegandFromEntry": [
        "o:w",
        "o{orgId}-hw:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "requestPackageUpgrade": [
        "o{orgId}-account:w",
        "o{orgId}-admin:w",
        "o{orgId}-alertSettings:w",
        "o{orgId}-configurations:w",
        "o{orgId}-credential:w",
        "o{orgId}-dash:w",
        "o{orgId}-dashActivity:w",
        "o{orgId}-entryState:w",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:w",
        "o{orgId}-ldp:w",
        "o{orgId}-mobileAppSettings:w",
        "o{orgId}-outboundWebhooks:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-role:w",
        "o{orgId}-rpt:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:w"
    ],
    "resetAcuSwConfig": [
        "o:w"
    ],
    "resetApb": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "resetBilling": [
        "o-basic:w",
        "o:w"
    ],
    "revertCertOpal": [
        "o:w"
    ],
    "revertEntryTempState": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "rotateDmpCertificate": [
        "o:w"
    ],
    "rotateIntercomDirectoryQrCode": [
        "o:r",
        "o:w",
        "o{orgId}-opvideoIntercom:r",
        "o{orgId}-opvideoIntercom:w",
        "s-o:r",
        "s-o:w"
    ],
    "saveAcuSwConfigDeploy": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcuSwConfig-checkAcuSwConfigDeploy:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "sendCustomParcelEmail": [
        "o:r",
        "o:w",
        "o{orgId}-parcelMgmtParcels:r",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:r",
        "s-o:w"
    ],
    "sendInternalOrgSummaryEmail": [
        "o:w"
    ],
    "sendInternalRenewalEmail": [
        "o:w"
    ],
    "sendParcelReminders": [
        "o:w"
    ],
    "setAcuExpansionBoards": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "s-o:w"
    ],
    "setAcuLocationMeasurement": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "setAcuLocationMeasurementSelf": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-locationMeasurementSelf:w"
    ],
    "setAcuLocationRestriction": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "setAcuStatus": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-setAcuStatus:w"
    ],
    "setAcusToDeployTag": [
        "o:w"
    ],
    "setAcuSwConfigDeployAttempt": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcuSwConfig-setAcuSwConfigDeployAttempt:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "setAcuSwConfigDeployProgress": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcuSwConfig-setAcuSwConfigDeployProgress:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "setAcuSwConfigDeployResult": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcuSwConfig-setAcuSwConfigDeployResult:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "setAlarmConfigurationCameraIds": [
        "o:w",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:w"
    ],
    "setBillingCoupon": [
        "o-basic:w",
        "o:w",
        "s-o:w"
    ],
    "setBuildingFloorUnitCameraIds": [
        "o:w",
        "o{orgId}-building:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "setBuildingFloorUnitGroupIds": [
        "o:w",
        "o{orgId}-building:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "setBuildingFloorUnitUserIds": [
        "o:w",
        "o{orgId}-building:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "setCameraEntries": [
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:w"
    ],
    "setContactSensorToEntry": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setEntryStateTriggerMethodIds": [
        "o:w",
        "o{orgId}-entryState:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "setEntryTempState": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setGroupBuildingFloorUnitIds": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setGroupToSite": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setGroupToZone": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setGroupUserIds": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setGroupZoneGroups": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setGroupZoneIds": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setIdentityIdentityRoleIds": [
        "i:w"
    ],
    "setIdentityProviderGroupRelation": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setIdentityProviderGroupRelations": [
        "o:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setIdentityRoleScopeIds": [
        "i:w"
    ],
    "setIdentityToIdentityRole": [
        "i:w"
    ],
    "setIdentityUiState": [
        "i:w",
        "i{params.identityId}:w"
    ],
    "setLockdownPlanPermissions": [
        "o:w",
        "o{orgId}-ldp:w",
        "s-o:w"
    ],
    "setLockdownPlanZoneStates": [
        "o:w",
        "o{orgId}-ldp:w",
        "s-o:w"
    ],
    "setOpVideoDeviceFacadeBackgroundImage": [
        "o-basic:r",
        "o:r",
        "o{orgId}-opvideoDevice:r",
        "s-o:r"
    ],
    "setOrgCancellationStatus": [
        "o-basic:w",
        "o-support:w",
        "o:w",
        "o{orgId}-serviceCancellation:w"
    ],
    "setOrgPackagePlansSelectedPackagePlanIds": [
        "o-basic:w",
        "o:w",
        "o{orgId}-account:w",
        "o{orgId}-admin:w",
        "s-o:w"
    ],
    "setOrgStatus": [
        "o-basic:w",
        "o:w",
        "s-o:w"
    ],
    "setOrgWirelessLockDbEntries": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setReaderToEntry": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setRelayToEntry": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setRexToEntry": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setRoleScopeIds": [
        "o:w",
        "o{orgId}-role:w",
        "s-o:w"
    ],
    "setRoleSiteIds": [
        "o-role:w",
        "o:w",
        "o{orgId}-role:w",
        "s-o:w"
    ],
    "setRoleUserIds": [
        "o-role:w",
        "o:w",
        "o{orgId}-role:w",
        "s-o:w"
    ],
    "setSiteGroupIds": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setSiteLocationMeasurement": [
        "o:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "setSiteLocationRestriction": [
        "o:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "setSiteUserIds": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setThirdPartyReaderToEntry": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setThirdPartyWiegandToEntry": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setupMobileCredential": [
        "o-support:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setupWalletCredential": [
        "o-support:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setUserBuildingFloorUnitIds": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setUserGroupIds": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setUserRoleIds": [
        "o:w",
        "o{orgId}-role:w",
        "s-o:w"
    ],
    "setUserSiteIds": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setUserStatus": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setUserToGroup": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setUserToRole": [
        "o-role:w",
        "o:w",
        "o{orgId}-role:w",
        "s-o:w"
    ],
    "setUserToSite": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setUserToZone": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setUserZoneIds": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setUserZoneUsers": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "setWiegandToEntry": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setZoneGroupIds": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setZoneShareOrgIds": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setZoneUserIds": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setZoneZoneGroups": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "setZoneZoneUsers": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "shareZone": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "signAwareCameraCsr": [
        "o:r",
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-awareConversion:r",
        "o{orgId}-acu{params.acuId}:orgAcu-awareConversion:w"
    ],
    "signIdentityTermsAgreement": [
        "i{params.identityId}:identity-signIdentityTermsAgreement:w",
        "i{params.identityId}:w"
    ],
    "signOrgTermsAgreement": [
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w"
    ],
    "signParcels": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "signupOrg": [
        "o-basic:w",
        "o:w",
        "s-o-video:w",
        "s-o:w"
    ],
    "submitCobaltUserFeedback": [
        "o:r",
        "o:w",
        "o{orgId}-rpt:r",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:r",
        "o{orgId}-rptGeneral:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:r",
        "s-o:w"
    ],
    "suspendExpiredCredentialsWalletApples": [
        "o:w"
    ],
    "suspendExpiredUsersWalletApples": [
        "o:w"
    ],
    "syncAcu": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-syncAcu:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "syncAllegionMobiles": [
        "o:w"
    ],
    "syncAllPropertyManagementSystems": [
        "o:w",
        "s-o:w"
    ],
    "syncBilling": [
        "o:w"
    ],
    "syncEmailAlertSubscriptions": [
        "o:w",
        "o{orgId}-alertSettings:w",
        "o{orgId}-configurations:w",
        "s-o:w"
    ],
    "syncLastActivity": [
        "o:w"
    ],
    "syncMetrics": [
        "o:w"
    ],
    "syncMobile": [
        "o{orgId}-user{params.userId}:orgUser-syncMobile:w",
        "o{orgId}-user{params.userId}:w"
    ],
    "syncOrgs": [
        "o:w"
    ],
    "syncPricingConfig": [
        "o:w"
    ],
    "syncPropertyManagementSystem": [
        "o:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "syncThirdPartyDeviceShipmentInfo": [
        "o-support:w",
        "o:w"
    ],
    "syncUsersFromMigratedPartner": [
        "o:w"
    ],
    "syncUsersIdentityProvider": [
        "o:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "syncVideoProviderSubscriptions": [
        "o-basic:w",
        "o-supportVideo:w",
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:w"
    ],
    "syncWalletAppleDevice": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "syncWirelessGatewayDevices": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "syncWirelessLockGatewayDevices": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "syncWirelessLockProviderDevices": [
        "o:w",
        "o{orgId}-hw:w",
        "o{orgId}-integrations:w",
        "s-o:w"
    ],
    "triggerAcuConfigChange": [
        "o-support:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "triggerAcusConfigChange": [
        "o-support:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "triggerAcuSoftwareUpdate": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "triggerAcusSoftwareUpdate": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "triggerPermissionsChange": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "unassignAcu": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "unassignReader": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "uninstallApp": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "s-o:w"
    ],
    "unlabelSwConfig": [
        "o:w"
    ],
    "unprovisionMobile": [
        "o{orgId}-user{params.userId}:orgUser-unprovisionMobile:w",
        "o{orgId}-user{params.userId}:w"
    ],
    "unshareZone": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "unsignIdentityTermsAgreement": [
        "i{params.identityId}:identity-unsignIdentityTermsAgreement:w",
        "i{params.identityId}:w"
    ],
    "updateAccessSettings": [
        "o:w",
        "o{orgId}-admin:w"
    ],
    "updateAcu": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "updateAcuExpansionBoard": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "s-o:w"
    ],
    "updateAcuPort": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "updateAcuPortEol": [
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "updateAcuSwConfig": [
        "o:w"
    ],
    "updateAlarm": [
        "o:w",
        "o{orgId}-alarmActions:w",
        "o{orgId}-configurations:w"
    ],
    "updateAlarmConfiguration": [
        "o:w",
        "o{orgId}-alarmConfigurations:w",
        "o{orgId}-configurations:w"
    ],
    "updateAlarms": [
        "o:w",
        "o{orgId}-alarmActions:w",
        "o{orgId}-configurations:w"
    ],
    "updateAuthCert": [
        "o:w",
        "o{orgId}-cert:w",
        "o{orgId}-cert{params.authCertId}:w",
        "s-o:w"
    ],
    "updateBadgeConfig": [
        "o:w",
        "o{orgId}-badgePrinting:w",
        "o{orgId}-configurations:w",
        "o{orgId}-mobileAppSettings:w",
        "s-o:w"
    ],
    "updateBillableFeatures": [
        "o-basic:w",
        "o:w"
    ],
    "updateBuilding": [
        "o:w",
        "o{orgId}-building:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "updateBuildingFloor": [
        "o:w",
        "o{orgId}-building:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "updateBuildingFloorUnit": [
        "o:w",
        "o{orgId}-building:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "updateBundledSwConfig": [
        "o:w"
    ],
    "updateContactSensor": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateCredential": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateCredentialAction": [
        "o-support:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateCredentialConfig": [
        "o-support:w",
        "o:w"
    ],
    "updateCustomField": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateCustomFieldDropdownItem": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateCustomFieldDropdownItems": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateCustomFields": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateDashboard": [
        "o:w",
        "o{orgId}-dash:w",
        "s-o:w"
    ],
    "updateDeployTag": [
        "o:w"
    ],
    "updateEmailAlerts": [
        "o:w",
        "o{orgId}-alertSettings:w",
        "o{orgId}-configurations:w",
        "s-o:w"
    ],
    "updateEntry": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateEntryState": [
        "o:w",
        "o{orgId}-entryState:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "updateEvent": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateEvents": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateFeatureFlag": [
        "o-support:w",
        "o:w"
    ],
    "updateGenericInput": [
        "o:w",
        "o{orgId}-hw:w",
        "o{orgId}-site:w",
        "s-o:w"
    ],
    "updateGroup": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateGroupUserIds": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateGroupZoneGroups": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateHeliumCoder": [
        "i:w"
    ],
    "updateHookAction": [
        "o:w",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:w",
        "s-o:w"
    ],
    "updateIdentity": [
        "i:w",
        "i{params.identityId}:w"
    ],
    "updateIdentityNicknames": [
        "i:w",
        "i{params.identityId}:w"
    ],
    "updateIdentityPreferenceSet": [
        "i:w",
        "i{params.identityId}:w"
    ],
    "updateIdentityProvider": [
        "o:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateIdentityRole": [
        "i:w"
    ],
    "updateIntercomDirectory": [
        "o:w",
        "o{orgId}-opvideoIntercom:w",
        "s-o:w"
    ],
    "updateLicenseBundleSubscription": [
        "o-basic:w",
        "o:w",
        "o{orgId}-admin:w",
        "s-o:w"
    ],
    "updateLock": [
        "o:w"
    ],
    "updateLockdownPlan": [
        "o:w",
        "o{orgId}-ldp:w",
        "s-o:w"
    ],
    "updateMailroom": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "updateMap": [
        "o:w",
        "o{orgId}-dash:w",
        "o{orgId}-map:w",
        "s-o:w"
    ],
    "updateMapCamera": [
        "o:w",
        "o{orgId}-dash:w",
        "o{orgId}-map:w",
        "s-o:w"
    ],
    "updateMapExtra": [
        "o:w",
        "o{orgId}-dash:w",
        "o{orgId}-map:w",
        "s-o:w"
    ],
    "updateMfaCredential": [
        "i:w",
        "i{params.identityId}:w"
    ],
    "updateMobileAppConfig": [
        "o:w",
        "o{orgId}-admin:w",
        "s-o:w"
    ],
    "updateOpvideoDevice": [
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "s-o:w"
    ],
    "updateOpvideoIntercomProfile": [
        "o:w",
        "o{orgId}-opvideoIntercom:w",
        "s-o:w"
    ],
    "updateOpvideoIntercomProfileGroups": [
        "o:w",
        "o{orgId}-opvideoIntercom:w",
        "s-o:w"
    ],
    "updateOrg": [
        "o-basic:w",
        "o:w",
        "o{orgId}-account:w",
        "o{orgId}-admin:w",
        "o{orgId}-sos:w",
        "s-o-video:w",
        "s-o:w"
    ],
    "updateOrgBrandingPhoto": [
        "o-basic:w",
        "o:w",
        "o{orgId}-admin:w",
        "s-o-video:w",
        "s-o:w"
    ],
    "updateOrgFeatureFlag": [
        "o-support:w",
        "o:w"
    ],
    "updateOrgFeatureFlagByName": [
        "o-support:w",
        "o:w"
    ],
    "updateOrgFobAllegion": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateOrgLevelDefault": [
        "o:w",
        "o{orgId}-admin:w",
        "s-o:w"
    ],
    "updateOrgMaintenanceWindow": [
        "o-basic:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "updateOrgMaintenanceWindowDefinition": [
        "o-basic:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "updateOrgMaintenanceWindowMap": [
        "o-basic:w",
        "o:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "updateOrgNativeAppStatus": [
        "o:w",
        "s-o-video:w",
        "s-o:w"
    ],
    "updateOrgNoTourCredentialCommands": [
        "o:w",
        "s-o:w"
    ],
    "updateOrgPicture": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-mobileAppSettings:w",
        "s-o:w"
    ],
    "updateParcel": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "updateParcelPicture": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "updateParcels": [
        "o:w",
        "o{orgId}-parcelMgmtParcels:w",
        "s-o:w"
    ],
    "updateParentOrgConfig": [
        "o-basic:w",
        "o:w",
        "o{orgId}-erpParentStore:w"
    ],
    "updatePasswordHashTempForAware": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updatePropertyManagementSystem": [
        "o:w",
        "o{orgId}-integrations:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateReader": [
        "o-support:w",
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateRecipientControl": [
        "o-support:w",
        "o:w"
    ],
    "updateRelay": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateRequest": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w"
    ],
    "updateRex": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateRole": [
        "o-role:w",
        "o:w",
        "o{orgId}-role:w",
        "s-o:w"
    ],
    "updateRoleUserIds": [
        "o-role:w",
        "o:w",
        "o{orgId}-role:w",
        "s-o:w"
    ],
    "updateSchedule": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateSite": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "o{orgId}-sos:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateSiteGroupIds": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateSiteUserIds": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateSosFacilityCampus": [
        "o:w",
        "o{orgId}-sos:w"
    ],
    "updateSosFacilityOrg": [
        "o:w",
        "o{orgId}-sos:w"
    ],
    "updateSubscription": [
        "o:w",
        "o{orgId}-configurations:w",
        "o{orgId}-outboundWebhooks:w",
        "s-o:w"
    ],
    "updateSwBundle": [
        "o:w"
    ],
    "updateSwConfig": [
        "o:w"
    ],
    "updateTasksReportsSchedule": [
        "o:w",
        "o{orgId}-rpt:w",
        "o{orgId}-rptGeneral:w",
        "s-o:w"
    ],
    "updateThirdPartyDevice": [
        "o-support:w",
        "o:w"
    ],
    "updateThirdPartyReader": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateThirdPartyWiegand": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateTitaniumVersion": [
        "o:w"
    ],
    "updateUnusedInput": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateUser": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateUserCustomField": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateUserCustomFields": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateUserGroupIds": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateUserIntercomNotificationPreferenceSet": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "o{orgId}-user{params.userId}:w",
        "s-o:w"
    ],
    "updateUserPicture": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateUserPreferenceSet": [
        "o:w",
        "o{orgId}-user{params.userId}:w"
    ],
    "updateUserSiteIds": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateUserZoneUsers": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateVideoProvider": [
        "o:w",
        "o{orgId}-opvideoDevice:w",
        "o{orgId}-videoProviderLive:w",
        "o{orgId}-videoProviderPlayback:w",
        "s-o:w"
    ],
    "updateWalletAppleDevice": [
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "updateWalletAppleDeviceBundles": [
        "o:w"
    ],
    "updateWalletAppleDeviceStatuses": [
        "o:w"
    ],
    "updateWidget": [
        "o:w",
        "o{orgId}-dash:w",
        "s-o:w"
    ],
    "updateWiegand": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-hw:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateWirelessGateway": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateWirelessGatewayFirmware": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateWirelessGatewayFirmwareBatch": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateWirelessLock": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateWirelessLockFirmware": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateWirelessLockFirmwareBatch": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateWirelessLockGateway": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateWirelessLockGatewayFirmware": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateWirelessLockGatewayFirmwareBatch": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateWirelessLockReader": [
        "o:w",
        "o{orgId}-admin:w",
        "o{orgId}-integrations:w",
        "o{orgId}-quickStart:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateZone": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateZoneApbArea": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateZoneZoneGroups": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "updateZoneZoneUsers": [
        "o:w",
        "o{orgId}-site:w",
        "o{orgId}-siteGeneral:w",
        "s-o:w"
    ],
    "userSendFeedback": [
        "o{orgId}-user{params.userId}:orgUser-sendFeedback:w",
        "o{orgId}-user{params.userId}:w"
    ],
    "validateAcuSsmActivation": [
        "o:w",
        "o{orgId}-acu{params.acuId}:orgAcu-validateSsmActivation:w",
        "o{orgId}-hw:w",
        "s-o:w"
    ],
    "verifyEmail": [
        "o-user:w",
        "o:w",
        "o{orgId}-user:w",
        "s-o:w"
    ],
    "versionMigrationInfo": [
        "o-basic:r",
        "o-basic:w",
        "o-support:r",
        "o-support:w",
        "o:r",
        "o:w"
    ],
    "videoProviderDeeplink": [
        "o:r",
        "o:w",
        "o{orgId}-videoProviderLive:w",
        "s-o:w"
    ],
    "videoProviderSnapshot": [
        "o:r",
        "o:w",
        "o{orgId}-videoProviderLive:w",
        "s-o:w"
    ]
};

export { scopesByOperationId };
